import * as React from "react";
import { createRoot } from "react-dom/client";
import { FluentProvider, webLightTheme } from "@fluentui/react-components";
import { App as AntdApp, ConfigProvider } from "antd";
import { themeProps } from "@alphascriptsolutions/client-core";
import "../../styles/globals.css";
import App from "./App";

const rootElement: HTMLElement | null = document.getElementById("slideEditRoot");
const root = rootElement ? createRoot(rootElement) : undefined;

Office.onReady(() => {
  root?.render(
    <ConfigProvider
      theme={{
        ...themeProps,
        token: {
          ...themeProps.token,
          fontSize: 13,
        },
      }}
    >
      <AntdApp>
        <FluentProvider theme={webLightTheme}>
          <App />
        </FluentProvider>
      </AntdApp>
    </ConfigProvider>
  );
});
